import React from 'react';
import Select from 'react-select';

import '../../styles/select.scss';

const DefaultSelect = ({ label, input, meta, options, defaultValue, ...rest }, { t }) => {
  const handleChange = (value) => {
    if (input && typeof input.onChange === 'function') {
      input.onChange(value);
    }
  };
  return (
    <div className="default-select">
      {label && (
        <label className="input-label" htmlFor={input?.name}>
          {label}
        </label>
      )}
      <Select
        className={`${meta?.touched && meta?.error ? 'is-input-invalid' : ''} `}
        defaultValue={defaultValue}
        onChange={handleChange}
        options={options}
        blurInputOnSelect={true}
        {...rest}
      />
    </div>
  );
};

export default DefaultSelect;
